export default __webpack_public_path__ + "static/media/pic1.9590acf9.png";